// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9a30c9af","239":"ae33351a","455":"cfe3582f","488":"307650aa"}[chunkId] + ".chunk.js";
};